import React from 'react';
import {EntypoTree} from 'react-entypo-icons';

export function Landscaping({...rest}) {
  return <EntypoTree style={{fontSize: 35}} {...rest} />;
}
